import { getOnboardingSurveyStore } from '@/store/onboardingSurvey/actions';
import { findKey } from 'lodash-es';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { OnboardingGoals, OnboardingGoalsKeysEnum } from '../types';

const SURVEY_GOALS_QUESTION_KEY = 's3-q1';

const defaultGoals: OnboardingGoals = {
    isSendingMarketingEmailsAnswered: false,
    isSendingTransactionalEmailsAnswered: false,
    isSendingNewslettersAnswered: false,
    isGrowingAudienceAnswered: false,
    isConnectingViaAPIAnswered: false,
    isConnectingViaSMTPAnswered: false,
    isWantExploreAnswered: false,
    isWantExploreAnsweredOnly: false,
};

const surveyAnswersToGoalsMap: Record<string, Partial<OnboardingGoals>> = {
    's3-q1-a1': { isSendingMarketingEmailsAnswered: true },
    's3-q1-a2': { isSendingTransactionalEmailsAnswered: true },
    's3-q1-a3': { isSendingNewslettersAnswered: true },
    's3-q1-a4': { isGrowingAudienceAnswered: true },
    's3-q1-a5': { isConnectingViaAPIAnswered: true },
    's3-q1-a6': { isConnectingViaSMTPAnswered: true },
    's3-q1-a7': { isWantExploreAnswered: true },
};

export const useOnboardingGoals = (): OnboardingGoals => {
    const { completedFormData } = useSelector(getOnboardingSurveyStore);
    const tasksRef = useRef<OnboardingGoals>();

    if (tasksRef.current) {
        return tasksRef.current;
    }

    const goalsQuestion = completedFormData?.SurveyQuestions?.find(
        (question) => question.QuestionKey === SURVEY_GOALS_QUESTION_KEY
    );
    const answers =
        goalsQuestion?.Anwsers?.reduce(
            (answers: OnboardingGoals, answer): OnboardingGoals => ({
                ...answers,
                ...surveyAnswersToGoalsMap[answer.AnwserKey],
            }),
            defaultGoals
        ) ?? defaultGoals;

    answers.isWantExploreAnsweredOnly =
        answers.isWantExploreAnswered &&
        !findKey(answers, (value, key) => value && key !== OnboardingGoalsKeysEnum.IsWantExploreAnswered);

    tasksRef.current = answers;
    return answers;
};
